import { CURRENT_CONFIG } from '/@/api/http/config'

export const AMapConfig = {
  url: CURRENT_CONFIG.amapUrl,
  key: CURRENT_CONFIG.amapKey,
  gmapKey: CURRENT_CONFIG.gmapKey,
  version: '2.0',
  plugins: [
    'AMap.Scale',
    'AMap.ToolBar',
    'AMap.ControlBar',
    'AMap.ElasticMarker',
    'AMap.MapType',
    'AMap.Geocoder',
    'AMap.CircleEditor',
    'AMap.PolygonEditor',
    'AMap.PolylineEditor',
    'AMap.PolyEditor',
    'AMap.RangingTool',
    'AMap.Weather',
    'AMap.MouseTool',
    'AMap.MoveAnimation'
  ]
}
